import React from 'react';
import * as C from 'components/desktop';
import * as M from 'components/mobile';
import { v4 as uuidV4 } from 'uuid';

export const slides = [
  { id: 1, component: <C.Slide1 key={uuidV4()} /> },
  { id: 2, component: <C.Slide2 key={uuidV4()} /> },
  { id: 3, component: <C.Slide3 key={uuidV4()} /> },
  { id: 4, component: <C.Slide4 key={uuidV4()} /> },
  { id: 5, component: <C.Slide5 key={uuidV4()} /> },
  { id: 6, component: <C.Slide6 key={uuidV4()} /> },
];

export const mobileSlides = [
  { id: 1, component: <M.Slide1 key={uuidV4()} /> },
  { id: 2, component: <M.Slide2 key={uuidV4()} /> },
  { id: 3, component: <M.Slide3 key={uuidV4()} /> },
  { id: 4, component: <M.Slide4 key={uuidV4()} /> },
  { id: 5, component: <M.Slide5 key={uuidV4()} /> },
  { id: 6, component: <M.Slide6 key={uuidV4()} /> },
  { id: 7, component: <M.Slide7 key={uuidV4()} /> },
  { id: 8, component: <M.Slide8 key={uuidV4()} /> },
  { id: 9, component: <M.Slide9 key={uuidV4()} /> },
];
